export default {
    TABOOLA_ADS: 'TABOOLA_ADS',
    BACKSTAGE: 'BACKSTAGE',
};
